import { HttpService } from './http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NGXLogger } from "ngx-logger";
// import {
//   PauseReasonsModel,
//   UpdatePauseTypesPostModel,
//   UpdatePauseTypesResponse,
//   LogsSettingsModel,
//   AuditEntity,
//   LoginEntity,
//   GetAccessListRequest,
//   GetLogsRequest,
//   OperationEntity,
//   UsersGlobalProfilesModel,
//   TemplateProfile,
//   ChildProfile,
//   SaveProfileChanges,
//   SaveTemplateProfilesResponse,
//   CheckForActiveAgentsResponse
// } from '../../users/models';
import {
  PauseReasonsModel,
  UpdatePauseTypesPostModel,
  UpdatePauseTypesResponse,
  LogsSettingsModel,
  AuditEntity,
  LoginEntity,
  GetAccessListRequest,
  GetLogsRequest,
  OperationEntity,
  UsersUsergroupsModel,
  UserGroup,
  UserGroupLong,
  UsergroupProfile,
  UsergroupServiceQuality,
  SaveUsergroupChanges,
  SaveUsergroupChangesResponse,
  CheckForActiveAgentsResponse,
  UsersGlobalProfilesModel,
  TemplateProfile,
  ChildProfile,
  SaveProfileChanges,
  SaveTemplateProfilesResponse,
} from '../../users/models';


@Injectable({
  providedIn: 'root'
})

export class usersService {


  constructor(private http: HttpService, private logger: NGXLogger) { }

  public getPauseReasons(): Observable<PauseReasonsModel> {

    return this.http.getFromApi('/PauseReasons/GetPauseReasons');
  }

  public updatePauseTypes(payload: UpdatePauseTypesPostModel): Observable<UpdatePauseTypesResponse> {
    let body = JSON.stringify(payload);
    return this.http.postToApi(
      '/PauseReasons/UpdatePauseTypes',
      body
    );
  }

  public GetLogsSettings(): Observable<LogsSettingsModel> {
    return this.http.getFromApi('/UserLogs/GetLogsSettings');
  }

  public GetAuditOperationList(module: string): Observable<Array<OperationEntity>> {
    return this.http.getFromApi('/UserLogs/GetAuditOperationList?module=' + module);
  }

  public GetLogs(payload: GetLogsRequest): Observable<Array<AuditEntity>> {
    let body = JSON.stringify(payload);
    return this.http.postToApi('/UserLogs/GetLogs', body);
  }

  public GetAccessList(payload: GetAccessListRequest): Observable<Array<LoginEntity>> {
    let body = JSON.stringify(payload);
    return this.http.postToApi('/UserLogs/GetAccessList', body);
  }

  public GetUserGroups(): Observable<TemplateProfile[]> {
    return this.http.getFromApi('/ProfileTemplates/UserGroups');
  }

  public GetChildProfiles(profileId: number): Observable<ChildProfile[]> {
    return this.http.getFromApi('/ProfileTemplates/GetChildProfiles?profileId=' + profileId);
  }

  public GetProfileTemplates(): Observable<UsersGlobalProfilesModel> {
    return this.http.getFromApi('/ProfileTemplates/GetProfileTemplates');
  }

  public SaveTemplateProfiles(payload: SaveProfileChanges): Observable<SaveTemplateProfilesResponse> {
    const body = JSON.stringify(payload);
    return this.http.postToApi('/ProfileTemplates/SaveTemplateProfiles', body);
  }

  public CheckForActiveAgents(payload: SaveProfileChanges): Observable<CheckForActiveAgentsResponse> {
    const body = JSON.stringify(payload);
    return this.http.postToApi('/ProfileTemplates/CheckForActiveAgents', body);
  }
  // Users Filter methods
  public getFiltersetList(): Observable<any> {
    return this.http.getFromApi('/UsersFilter/Index');
  }

  public updateFiltersetList(payload: any): Observable<any> {
    let body = JSON.stringify(payload);
    return this.http.postToApi('/UsersFilter/UpdateFiltersetList', body);
  }

  public getFilter(filtersetId: number): Observable<any> {
    return this.http.getFromApi(`/UsersFilter/GetFilter?id=${filtersetId}`);
  }

  public getFiltersetResourceList(filtersetId: number, resourceType: number): Observable<any> {
    return this.http.getFromApi(`/UsersFilter/GetFiltersetResourceList?id=${filtersetId}&resourceType=${resourceType}`);
  }

  public getAvailableResourcesPrType(filtersetId: number, resType: number): Observable<any> {
    return this.http.getFromApi(`/UsersFilter/GetAvailableResourcesPrType?id=${filtersetId}&resType=${resType}`);
  }

  public updateFilterset(filtersetId: number, resourcetypeId: number, payload: any): Observable<any> {
    let body = JSON.stringify(payload);
    return this.http.postToApi(`/UsersFilter/UpdateFilterset?filtersetId=${filtersetId}&resourcetypeId=${resourcetypeId}`, body);
  }

  // User Groups methods
  public getUsersUsergroups(): Observable<UsersUsergroupsModel> {
    return this.http.getFromApi('/UsersUsergroups/Index');
  }

  public getUserGroupList(): Observable<UserGroup[]> {
    return this.http.getFromApi('/UsersUsergroups/GetUsergroupList');
  }

  public getUserGroupNamefromId(usergroupId: number): Observable<UserGroupLong> {
    return this.http.getFromApi(`/UsersUsergroups/GetUserGroupNamefromId?usergroupId=${usergroupId}`);
  }

  public getUserGroupProfiles(usergroupId: number): Observable<UsergroupProfile[]> {
    return this.http.getFromApi(`/UsersUsergroups/GetUserGroupProfiles?usergroupId=${usergroupId}`);
  }

  public getCustomerSkills(): Observable<UsergroupServiceQuality[]> {
    return this.http.getFromApi('/UsersUsergroups/GetCustomerSkills');
  }

  public saveUsergroupChanges(payload: SaveUsergroupChanges): Observable<SaveUsergroupChangesResponse> {
    let body = JSON.stringify(payload);
    return this.http.postToApi('/UsersUsergroups/SaveUsergroupChanges', body);
  }

  public checkForActiveAgents(payload: SaveUsergroupChanges): Observable<CheckForActiveAgentsResponse> {
    let body = JSON.stringify(payload);
    return this.http.postToApi('/UsersUsergroups/CheckForActiveAgents', body);
  }

  public createNewUsergroup(usergroupName: string, groupType: number): Observable<boolean> {
    const params = new URLSearchParams();
    params.append('usergroupName', usergroupName);
    params.append('groupType', groupType.toString());
    return this.http.postToApi(`/UsersUsergroups/CreateNewUsergroup?${params.toString()}`, '');
  }

  public createUserGroupBasedOnUserGroup(usergroupName: string, origUserGroupId: number): Observable<boolean> {
    const params = new URLSearchParams();
    params.append('usergroupName', usergroupName);
    params.append('origUserGroupId', origUserGroupId.toString());
    return this.http.postToApi(`/UsersUsergroups/CreateUserGroupBasedOnUserGroup?${params.toString()}`, '');
  }

  public deleteUsergroup(usergroupId: number): Observable<any> {
    return this.http.postToApi(`/UsersUsergroups/DeleteUsergroup?usergroupId=${usergroupId}`, '');
  }

  public getUsergroupUserList(usergroupId: number): Observable<any> {
    return this.http.getFromApi(`/UsersUsergroups/GetUsergroupUserList?usergroupId=${usergroupId}`);
  }

  public checkIfProfileNameIsAvailable(usergroupId: number, newProfileName: string, profileId?: number, usergroupsProfilesRemoved?: number[]): Observable<number> {
    const params = new URLSearchParams();
    params.append('usergroupId', usergroupId.toString());
    params.append('newProfileName', newProfileName);
    if (profileId) params.append('profileId', profileId.toString());
    if (usergroupsProfilesRemoved) {
      usergroupsProfilesRemoved.forEach(id => params.append('usergroupsProfilesRemoved', id.toString()));
    }
    return this.http.getFromApi(`/UsersUsergroups/CheckIfProfileNameIsAvailable?${params.toString()}`);
  }
}
